import DoAPICall from './DoAPICall'

//Create Client Mno
    export async function createClientPaymentsProvider(userToken, clientPaymentsProvider){
        const apiPayload = {
            httpMethod:'post',
            userToken,
            uri:'clientwallets',
            payLoad:{
                payments_provider_id:clientPaymentsProvider.payments_provider_id,
                paymentsCommission:clientPaymentsProvider.paymentsCommission,
                paymentsActive:clientPaymentsProvider.paymentsActive,
                paymentMethod:clientPaymentsProvider.paymentMethod,
                paymentsMode:clientPaymentsProvider.paymentsMode,
                modeMessage:clientPaymentsProvider.modeMessage,
                client_id:clientPaymentsProvider.client_id,
                handler:clientPaymentsProvider.handler
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get All Client mno
    export async function getClientPaymentsProviders(userToken){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'clientwallets',
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get One Client mno
    export async function getClientPaymentsProvider(userToken, id){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'clientwallets/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get Payments Providers of client
export async function getWalletsOfClient(userToken,client_id){
    const apiPayload = {
        httpMethod:'get',
        userToken,
        uri:'walletsofclient/'+client_id,
        payLoad:{},
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}

//Update Client mno
    export async function updateClientPaymentsProvider(userToken, clientPaymentsProvider){
        const apiPayload = {
            httpMethod:'put',
            userToken,
            uri:'clientwallets/'+clientPaymentsProvider.id,
            payLoad:{
                payments_provider_id:clientPaymentsProvider.payments_provider_id,
                paymentsCommission:clientPaymentsProvider.paymentsCommission,
                paymentsActive:clientPaymentsProvider.paymentsActive,
                paymentMethod:clientPaymentsProvider.paymentMethod,
                paymentsMode:clientPaymentsProvider.paymentsMode,
                modeMessage:clientPaymentsProvider.modeMessage,
                client_id:clientPaymentsProvider.client_id,
                handler:clientPaymentsProvider.handler
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Delete Client Mno
    export async function deleteClientPaymentsProvider(userToken, id){
        const apiPayload = {
            httpMethod:'delete',
            userToken,
            uri:'clientwallets/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }
